const phoneRegex = /^(?<country>\+\d{1,2}\s)?[ -]?(?:\(?(?<areaCode>\d{3})\)?)?[ -]?(?<rest>[\s.-]?\d{3}[\s.-]?\d{4})$/gm;
export const destructurePhone = (phoneNumber) => {
    const match = phoneRegex.exec(phoneNumber);
    phoneRegex.lastIndex = 0;
    return {
        areaCode: match?.groups?.areaCode,
        countryCode: match?.groups?.country,
        rest: match?.groups?.rest,
        raw: phoneNumber,
    };
};
export const cleanPhoneNumber = (phoneNumber) => `${phoneNumber}`.replace(/\D/g, '');
/**
 * Formats phone number e.g. `"800-555-1212"`
 * @param phoneNumber Unformatted phone number
 * @returns Formatted phone number
 */
export const formatPhoneNumber = (phoneNumber, extensionPrefix = 'x', forceInternational = false) => {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})(.*)$/);
    if (!match)
        return undefined;
    const intlCode = forceInternational || match[1] ? '+1 ' : '';
    const parts = [intlCode, match[2], '-', match[3], '-', match[4]];
    const extension = match[5];
    if (extension) {
        parts.push(` ${extensionPrefix}${extension}`);
    }
    return parts.join('');
};
export const cleanUsPhoneWithPlusOne = (phoneNumber) => {
    let cleaned = cleanPhoneNumber(phoneNumber);
    if (cleaned[0] !== '1')
        cleaned = `1${cleaned}`;
    if (cleaned.length !== 11)
        throw new Error('invalid US phone number');
    return `+${cleaned}`;
};
